export default __webpack_public_path__ + "6448f60260a54492d5276ac4148cd086.jpg";